@if (!loading){

<div class="row section__header">
    <div class="col-12">
        @if (bookingGuid) {
        <h1 class="text-center">EDIT YOUR BOOKING</h1>
        } @else {
        @if (therapistId > 0 && therapistName){
        <h1 class="text-center font-weight-bold">BOOK YOUR SESSION </h1>
                    <div class="row section__header">
        <div class="col-12">
            <h3 class="text-center font-weight-bold text-uppercase mb-0">{{eventName}}</h3>
            <p class="text-center text-uppercase">{{eventStartDate|date:'dd MMM YYYY'}} - {{eventEndDate|date:'dd MMM YYYY'}}</p>
        </div>
    </div>
        <p class="text-center">Your session will be with {{ therapistName }}
        </p>
        } @else{
        <h1 class="text-center">BOOK YOUR SESSION</h1>
                    <div class="row section__header">
        <div class="col-12">
            <h3 class="text-center font-weight-bold text-uppercase mb-0">{{eventName}}</h3>
            <p class="text-center text-uppercase">{{eventStartDate|date:'dd MMM YYYY'}} - {{eventEndDate|date:'dd MMM YYYY'}}</p>
        </div>
    </div>
        <p class="text-center  font-weight-bold">Your sesison will be with the next availalbe therapist</p>
        }
        }
    </div>
</div>

<form [formGroup]="bookingForm" class="book-session__form">
    <div class="row g-3">
      
           
        <div class="col-12">

            <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
                <mat-label>Name</mat-label>
                <input type="text" matInput formControlName="name" placeholder="Eg. John Smith">
                @if (bookingForm.get('name')?.hasError('minlength') &&
                !bookingForm.get('name')?.hasError('required')) {
                <mat-error>Please enter a valid name</mat-error>
                }
                @if (bookingForm.get('name')?.hasError('required')) {
                <mat-error>Name is <strong>required</strong></mat-error>
                }
            </mat-form-field>
        </div>


@if (!isTherapist && !isAppUser){
<div class="col-12 mobile-input__outer" [class.mobile-input__outer--error]="(bookingForm.get('mobile')?.touched && bookingForm.get('mobile')?.invalid) || (bookingForm.get('mobile')?.touched && bookingForm.get('mobile')?.hasError('minlength') && !bookingForm.get('mobile')?.hasError('required'))">
        <ngx-intl-tel-input
        [cssClass]="'phone-with-dialling-code__input'"
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [searchCountryField]="[
          SearchCountryField.Iso2,
          SearchCountryField.Name
        ]"
        [selectFirstCountry]="false"
        [selectedCountryISO]="CountryISO.UnitedKingdom"
        [maxLength]="15"
        [phoneValidation]="true"
        [enablePlaceholder]="false"
        customPlaceholder="Mobile number"
        [separateDialCode]="separateDialCode"
        [numberFormat]="PhoneNumberFormat.National"
        name="phone"
        formControlName="mobile"
      >
      </ngx-intl-tel-input>
      <span class="mobile-input__error">

@if(bookingForm.get('mobile')?.touched && bookingForm.get('mobile')?.invalid){
    <mat-error>Please enter a valid mobile number</mat-error>
}

               @if (bookingForm.get('mobile')?.touched && bookingForm.get('mobile')?.hasError('required')) {
                <mat-error>Mobile number is <strong>required</strong> so we can keep you updated about your booking.</mat-error>
                }</span>
      </div>

        <div class="col-12">

            <mat-label [class.invalid-label]="(bookingForm.get('contactMethodID')?.touched && bookingForm.get('contactMethodID')?.hasError('required'))" class="mb-2">How would you like to be communicated with?</mat-label>
            <br>
            <mat-button-toggle-group class="mt-2" formControlName="contactMethodID">
                <mat-button-toggle [value]="1">SMS</mat-button-toggle>
                <mat-button-toggle [value]="2">Whatsapp</mat-button-toggle>
            </mat-button-toggle-group>
            <div class="mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align">
                @if (bookingForm.get('contactMethodID')?.touched &&
                bookingForm.get('contactMethodID')?.hasError('required')) {
                <mat-error style="margin-top: -20px;">Contact method is <strong>required</strong> so we can keep you updated about your booking.</mat-error>
                }
            </div>
        </div>
    }


        <div class="col-12">
            <mat-form-field subscriptSizing="dynamic" class="w-100" appearance="outline" hideRequiredMarker="true">
                <mat-label>Location</mat-label>
                <input type="text" matInput formControlName="location" placeholder="Eg. Table 1, Seat 3">
                    <mat-hint>Enter your table / seat number and tournament / room info.</mat-hint>
                @if (bookingForm.get('location')?.hasError('required')) {
                <mat-error>Location is <strong>required</strong> to enable our therapist to find you. Enter your table / seat number and tournament / room info.</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="col-12">
            <mat-form-field subscriptSizing="dynamic" class="w-100" appearance="outline" hideRequiredMarker="true">
                <mat-label>Notes</mat-label>
                <input type="text" matInput formControlName="otherNotes" placeholder="Eg. Red shirt">
                                    <mat-hint>Let us know what colour top you're wearing or any distinguishing features.</mat-hint>
                                    @if (bookingForm.get('otherNotes')?.hasError('required')) {
                <mat-error>Notes are <strong>required</strong> to enable our therapist to find you. Let us know what you're wearing or any distinguishing features</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="col-12">
            @if (bookingGuid){
            <button (click)="updateBooking();" class="w-100" mat-flat-button color="primary">AMEND BOOKING</button>
            }@else{
            <button (click)="createBooking();" class="w-100" mat-flat-button color="primary">BOOK NOW</button>
            }
            @if (bookingFormSubmit){
            <div class="wh-button__progress-bar">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            }

        </div>
        <div class="col-12">

        </div>
    </div>
</form>
} @else {
    <div class="wh-loading-bar">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
}
